import { render, staticRenderFns } from "./admin.user-roles.vue?vue&type=template&id=0c28d920&"
import script from "./admin.user-roles.vue?vue&type=script&lang=js&"
export * from "./admin.user-roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports